module.exports = __webpack_public_path__ + "img/news-img2.8cdf2f39.svg";